// shout out to stack overflow, making our lives easier since 2008: https://stackoverflow.com/a/21125098
export function getCookieValue(cookie: string, cookieName: string) {
  const match = new RegExp('(^| )' + cookieName + '=([^;]+)').exec(cookie);
  return match ? match[2] : null;
}
